import axios from "axios";

export const APIConfig = axios.create({
  baseURL: process.env.REACT_APP_API_ENDPOINT_DUPLICATE,
  withCredentials: true,
});
